class roomSetup extends HTMLElement {
  constructor() {
    super();
    this.roomData = JSON.parse(document.querySelector('[data-room-setup-json]').textContent)
    this.typeInput = this.querySelectorAll('input[name="room_type"]');
    this.systemSelectionEle = this.querySelector('select[name="type_of_system"]');
    this.placeholderImageEle = this.querySelector('[data-room-img] img');
    this.overviewContentEle = this.querySelector('[data-overview-content-wrapper]');
    this.hotSpotsWrapperEle = this.querySelector('[data-hotspots]');
    this.overviewTrigger = this.querySelectorAll('[data-display-overfiew],[data-close-overview]');
    this.productRecommendedModelTrigger = this.querySelectorAll('[data-trigger-recommended-rel],[data-close-recommended-rel]');
    this.productRecommendedModelEle = this.querySelector('[data-room-setup-recommends]');
    this.overlay = this.querySelector('[data-overlay]');
  }

  connectedCallback(){
    this.typeInput?.forEach(input => {
      input.addEventListener('change', this.onSetupChange.bind(this));
    })
    this.systemSelectionEle.addEventListener('change', this.onSystemChange.bind(this));
    this.overviewTrigger.forEach(btn => btn.addEventListener('click', this.toggleOverView.bind(this)));
    
    this.productRecommendedModelTrigger.forEach(btn => btn.addEventListener('click', this.toggleProductRecommendedModel.bind(this)));

    this.overlay?.addEventListener('click', (e) => {
      e.preventDefault();
      this.querySelectorAll('.hot-spot-item-wrapper')?.forEach(item => item.classList.remove('active'))
      this.overlay.classList.remove('active');
      document.body.classList.remove('scroll-fixed');
    })
    window.addEventListener("pageshow", () => {
      this.systemSelectionEle.value = '';
    });
  }

  
  /**
   * This functionality will handle and manage the behaviour of room setup images and type of system data manipulation
   * @param {event} e: this is the event param used for event listner's bind function
   */
  onSetupChange(e) {
    e.preventDefault();
    let value = e.currentTarget.value;
    let systemOptions = Object.values(this.roomData.speakerData).filter(item => item.type === value);
    
    // remove the existing type of system options
    Array.from(this.systemSelectionEle.options).forEach(option => {
      if (!option.disabled) {
        option.remove();
      } else {
        option.selected = true; // Mark disabled options as selected
      }
    });

    // update the type of system options
    systemOptions.forEach(item => {
      const option = document.createElement('option');
      option.value = item.typeOfSystem; // Set the value of the option
      option.textContent = item.typeOfSystem; // Set the display text of the option
      this.systemSelectionEle.appendChild(option);
    });

    // update the placeholder image
    this.updatePlceholderImage(this.roomData.placeholders[value]);

    // Reset hotspots
    this.renderHotSpots();

    this.overviewContentEle.classList.add('d-none');
  }


  /**
   * This functionality will replace and udpate the image of room setup placeholder with selected option
   * @param {String} imgSrc: Image srource to udpate in the img tag
   */
  updatePlceholderImage(imgSrc) {
    if (this.placeholderImageEle) {
      this.placeholderImageEle.src = imgSrc;

      this.placeholderImageEle.classList.add('changing');
      setTimeout(() => {
        this.placeholderImageEle.classList.remove('changing');
      }, 150);
    };
  }

  /**
   * This functionality will handle the data of room setup for selected option including changing placeholder image, showing hotspots providng speaker recommendations etc.
   * @param {event} e: this is the event param used for event listner's bind function
   */
  onSystemChange = async (e) => {
    e.preventDefault();
    let currValue = e.currentTarget.value;
    let selector = currValue.toLowerCase().replaceAll('+', '-').replaceAll('.', '-').replaceAll(' ', '-');
    let roomsetupData = this.roomData.speakerData[selector];

    if(roomsetupData && roomsetupData.overview) {
      this.overviewContentEle.classList.remove('d-none');
      this.overviewContentEle.querySelectorAll('[data-overview-content-short]').forEach(ele => ele.innerHTML = roomsetupData.overviewShort);
      this.overviewContentEle.querySelectorAll('[data-overview-content-full]').forEach(ele => ele.innerHTML = roomsetupData.overview);
    } else {
      this.overviewContentEle.classList.add('d-none');
    };

    if(roomsetupData && Object.keys(roomsetupData.productList).length === 0) {
      this.productRecommendedModelTrigger?.forEach(btn => btn.classList.add('d-none'));
    } else {
      this.productRecommendedModelTrigger?.forEach(btn => btn.classList.remove('d-none'));
    }

    // update the placeholder image
    this.updatePlceholderImage(roomsetupData.roomImage);

    // Render hotspots
    this.renderHotSpots(roomsetupData.HotSpots);

    let recommendedProducts = roomsetupData.productList || [];
    await this.renderRecommendatedProducts(recommendedProducts);
  }

  /**
   * This funcitonality is used to render and display the hotspots tooltips over the placeholder image of the page
   * @param {Object} data: This object contains position of hotsports and html content to render on the page
   */
  renderHotSpots(data) {
    this.hotSpotsWrapperEle.innerHTML = '';
    if (!data) { return false;}
  
    let html = Object.entries(data).map(([key, spot], index) => {
      return `
      ${spot.title != '' && spot.content != '' ? 
        `<div class="hot-spot-item-wrapper ${spot.topAxis > 65 ? 'tooltip-top' : 'tooltip-bottom'} ${spot.leftAxis > 65 ? 'tooltip-left' : spot.leftAxis > 36 ? 'tooltip-middle' : 'tooltip-right'}" style="--left: ${spot.leftAxis}%;--top: ${spot.topAxis}%;">

          <span class="hotspot-dot d-inline-flex align-items-center justify-content-center fw-semibold lh-1 fs-md">${index +1}</span>
          <div class="hotspot-content">
            <div class="sec-header d-flex align-items-center flex-wrap justify-content-between mb-1">
              ${spot.title ? `<p class="h6 text-primary">${spot.title}</p>` : ''}
              <button type="button" class="p-0 border-0 text-body bg-transparent icon-close icon-size-11" data-product-hotspot-close></button>
            </div>
            <div class="modal-content">
              ${spot.content ? `<div class="rte">${spot.content}</div>` : ''}
            </div>
          </div>
        </div>`
      : '' }`;
    }).join('');
  
    this.hotSpotsWrapperEle.innerHTML = html;

    this.toggleToolTips(this.querySelectorAll('.hot-spot-item-wrapper .hotspot-dot,[data-product-hotspot-close]'));
  }

  /**
   * Toggle on click for hotspots
   * @param {nodeList} tooltips: list of tooptip selectors
   */
  toggleToolTips(tooltips) {
    if (!tooltips || !tooltips.length) return false;

    tooltips.forEach(tooltip => {
        tooltip.addEventListener('click', (e) => {
            e.preventDefault();

            const wrapper = tooltip.closest('.hot-spot-item-wrapper');
            if (!wrapper) return;

            let mainWrapper = e.currentTarget.closest('.hotspots-wrapper');

            // Close the tooltip if it's already open
            if (e.currentTarget.hasAttribute('data-product-hotspot-close')) {
                wrapper.classList.remove('active');
                this.overlay.classList.remove('active');
                if (window.innerWidth <= 1199) document.body.classList.remove('scroll-fixed');
            } else {
                // If the clicked tooltip is already active, remove the active class
                const isActive = wrapper.classList.contains('active');
                
                // Deactivate all other tooltips
                tooltips.forEach(tip => {
                    const tipWrapper = tip.closest('.hot-spot-item-wrapper');
                    if (tipWrapper && tip !== e.currentTarget) {
                        tipWrapper.classList.remove('active');
                        this.overlay.classList.remove('active');
                        if (window.innerWidth < 1199) document.body.classList.remove('scroll-fixed');
                    }
                });

                // If the clicked tooltip was not already active, toggle it
                if (!isActive) {
                    wrapper.classList.add('active');
                    this.overlay.classList.add('active');
                    setTimeout(() => {
                      if (mainWrapper) { mainWrapper.insertAdjacentElement('afterbegin', wrapper); }
                    }, 250);
                    if (window.innerWidth <= 1199) document.body.classList.add('scroll-fixed');
                } else {
                    // If it's already active, remove it
                    wrapper.classList.remove('active');
                    this.overlay.classList.remove('active');
                    if (window.innerWidth <= 1199) document.body.classList.remove('scroll-fixed');
                }
            }
        });
    });

    document.addEventListener('click', (e) => {
      const target = e.target;
      const isInsideHotspot = target.closest('.hot-spot-item-wrapper');

      // If the click is outside the hot-spot-item-wrapper, hide the overlay and deactivate tooltips
      if (!isInsideHotspot) {
          tooltips.forEach(tooltip => {
              const wrapper = tooltip.closest('.hot-spot-item-wrapper');
              if (wrapper) {
                  wrapper.classList.remove('active');
              }
          });
          this.overlay.classList.remove('active');
          if (window.innerWidth <= 1199) document.body.classList.remove('scroll-fixed');
      }
    });
  }

  /**
   * This funcitonality will toggle the overview content and display it on full window 
   * @param {event} e: this is the event param used for event listner's bind function
   */
  toggleOverView(e) {
    e.preventDefault();
    if (window.innerWidth >= 1200) {
      e.currentTarget.closest('[data-overview-content-wrapper]').classList.toggle('active');
    } else {
      let ctaBtn = this.querySelector('[data-display-overfiew]');
      if (ctaBtn.dataset.text == 'read-more') {
        ctaBtn.textContent = 'Read Less';
        ctaBtn.dataset.text = 'read-less'
      } else {
        ctaBtn.textContent = 'Read More';
        ctaBtn.dataset.text = 'read-more'
      }
      this.querySelector('.desktop-content-wrapper').classList.toggle('active');
      Utility.slideToggle(this.querySelector('.desktop-content-wrapper [data-overview-content-short]'));
      Utility.slideToggle(this.querySelector('.desktop-content-wrapper [data-overview-content-full]'));
    }
  }

  /**
   * This functionality will toggle the product recommendations modal
   */
  toggleProductRecommendedModel = async (e) => {
    e.preventDefault();
    this.productRecommendedModelEle.classList.toggle('active');
    setTimeout(() => {
      if(window.innerWidth <= 991) document.body.classList.toggle('scroll-fixed');
    }, 100);
  }

  /**
   * This function will fetch and display the product recommendations of room setup system
   */
  renderRecommendatedProducts = async (productData) => {
    let product_handles = [];
    if (Object.keys(productData).length === 0) {
      product_handles = 'no-results';
      return false
    } else {
      Object.values(productData).map(item => product_handles.push(item.handle))
    }
    await fetch(`/?section_id=room-setup-tool&room-setup-recommendations=${product_handles}`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-room-setup-tool').innerHTML;
      this.productRecommendedModelEle.innerHTML = resultsMarkup;
      this.querySelector('[data-close-product-recommendations]')?.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.remove('scroll-fixed');
        this.productRecommendedModelEle.classList.remove('active');
      });
    })
    .catch((error) => {
        this.predictiveSearchResults.setAttribute('loading', false);
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        throw error;
    });
  }
}
customElements.define('room-setup', roomSetup);